<template>
  <div class="relative flex" :dir="isRTLView ? 'rtl' : 'ltr'">
    <multiselect
      ref="multiselect"
      v-model="onConversationOrderByChange"
      :options="$t('CHAT_LIST.SORT_ORDER_ITEMS_BY_GROUP')"
      group-values="items"
      group-label="group_name"
      track-by="value"
      label="name"
      :show-labels="false"
      class="no-margin"
      :searchable="false"
      :allow-empty="false"
    >
      <template slot="singleLabel" slot-scope="props">
        <div
          v-tooltip.right="$t('CHAT_LIST.SORT_TOOLTIP_LABEL')"
          class="flex flex-row items-center gap-1 cursor-pointer"
        >
          <span class="p-[3px]">
            <svg
              width="10"
              height="12"
              viewBox="0 0 10 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.87174 8.89746L4.17578 8.20085L2.93555 9.43066L2.93555 -0.00032546L1.93555 -0.000325372L1.93555 9.43066L0.695963 8.20085L-2.12922e-07 8.89746L2.43555 11.333L4.87174 8.89746ZM9.86654 1.49967C9.94017 1.49967 10 1.43985 10 1.36621L10 0.633138C10 0.5595 9.94017 0.499674 9.86654 0.499674L4.13346 0.499674C4.05982 0.499674 4 0.5595 4 0.633138L4 1.36621C4 1.43985 4.05983 1.49967 4.13346 1.49967L9.86654 1.49967ZM9.19987 3.16634C9.27351 3.16634 9.33333 3.10652 9.33333 3.03288L9.33333 2.2998C9.33333 2.22617 9.27351 2.16634 9.19987 2.16634L4.13346 2.16634C4.05983 2.16634 4 2.22617 4 2.29981L4 3.03288C4 3.10652 4.05983 3.16634 4.13346 3.16634L9.19987 3.16634ZM8.34505 4.83301C8.41868 4.833 8.47852 4.77318 8.47852 4.69954L8.47851 3.96647C8.47851 3.89284 8.41868 3.83302 8.34505 3.83301L4.13346 3.83301C4.05983 3.83301 4 3.89283 4 3.96647L4 4.69954C4 4.77318 4.05983 4.83301 4.13346 4.83301L8.34505 4.83301ZM7.19987 6.49967C7.27351 6.49967 7.33333 6.43985 7.33333 6.36621L7.33333 5.63314C7.33333 5.5595 7.27351 5.49967 7.19987 5.49967L4.13346 5.49967C4.05983 5.49967 4 5.5595 4 5.63314L4 6.36621C4 6.43985 4.05983 6.49967 4.13346 6.49967L7.19987 6.49967Z"
                fill="#6B7280"
                style="
                  fill: #6b7280;
                  fill: color(display-p3 0.4196 0.4471 0.502);
                  fill-opacity: 1;
                "
              />
            </svg>
          </span>
        </div>
      </template>
      <template #caret><span class="hidden" /></template>
    </multiselect>
  </div>
</template>
<script>
import wootConstants from 'dashboard/constants/globals';
import { mapGetters } from 'vuex';
import rtlMixin from 'shared/mixins/rtlMixin';

export default {
  mixins: [rtlMixin],
  data() {
    return {
      conversationOrderBy:
        this.chatSortFilter || wootConstants.SORT_BY_TYPE.LATEST,
    };
  },
  computed: {
    ...mapGetters({
      chatSortFilter: 'getChatSortFilter',
    }),
    onConversationOrderByChange: {
      get() {
        const allItems = this.$t('CHAT_LIST.SORT_ORDER_ITEMS_BY_GROUP').flatMap(
          group => group.items
        );
        const result = allItems.find(i => i.value === this.conversationOrderBy) || null;
        return result;
      },
      set(option) {
        this.$store.dispatch('setChatSortFilter', option.value);
        this.$emit('onSortbyChange', option.value);
      },
    },
  },
  watch: {
    chatSortFilter(value) {
      this.conversationOrderBy = value;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .multiselect {
    min-height: auto;
    cursor: pointer;
    .multiselect__tags {
      min-height: unset;
      border: 1px solid #e5e7eb;
      padding-left: 0;
      padding-right: 0px;
      border-radius: 4px;
      background: white;
      width: 32px;
      height: 32px;

      .multiselect__single {
        padding: 4px;
        background: transparent;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;

        .has-tooltip {
          justify-content: center;
        }

        &:hover {
          @apply bg-gray-50 border-gray-200;
        }
      }

      .multiselect__placeholder {
        margin: 0;
        padding: 0;
      }
    }

    &.multiselect--active {
      .multiselect__tags {
        @apply bg-gray-50 border-gray-200;
      }
    }

    .multiselect__content-wrapper {
      border-radius: 8px;
      top: calc(100% + 5px);
      width: 200px;
      right: 0;

      .multiselect__content {
        .multiselect__option {
          padding: 10px 12px;
          font-size: 16px;
          min-height: unset;
          display: flex;
          align-items: center;

          &.multiselect__option--selected {
            background: white;
          }

          &.multiselect__option--group {
            background: white !important;
            text-transform: uppercase;
            font-size: 12px;
            padding: 4px 12px;
            color: #9CA3AF;
            height: 30px;
            font-weight: 600;
          }
        }

        .multiselect__option.multiselect__option--selected,
        .multiselect__option.multiselect__option--highlight:hover,
        .multiselect__option.multiselect__option--selected.multiselect__option--highlight:hover {
          @apply bg-[#F0FDF4];

          span {
            @apply text-[#164B35];
          }

          &::after {
            @apply bg-[#F0FDF4];
          }
        }
      }

      &::-webkit-scrollbar {
        width: 3px;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        @apply bg-gray-300 rounded-full;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        background-clip: content-box;
      }

      &::-webkit-scrollbar-thumb:hover {
        @apply bg-gray-400;
        background-clip: content-box;
      }
    }

    &.multiselect--active {
      .multiselect__tags {
        min-height: unset;

        .multiselect__input {
          height: auto;
          font-weight: 600;
          color: #4B5563;
          line-height: 20px;
          padding: 4px;
          background: transparent;
        }
      }
    }

    .multiselect__option.multiselect__option--selected {
      background: #f0fdf4;
      &:after {
        background-image: url(/images/checked.svg);
        width: 11px;
        height: 8px;
        background-origin: content-box;
        background-position-x: center;
        background-repeat: no-repeat;
        background-size: 11px 8px;
        top: 50%;
        transform: translateY(-50%);
        right: 12px;
        padding: 0;
      }
    }
  }

  &[dir='rtl'] {
    .multiselect {
      .multiselect__content-wrapper {
        left: 0;
        right: unset;
      }

      .multiselect__option.multiselect__option--selected {
        &:after {
          right: unset;
          left: 12px;
        }
      }
    }
  }
}
</style>
